import styled from 'styled-components';
import { vw } from 'components/common/Common';
import { H3, Li, Span, SvgIcon } from '../Jet.style';

const Sections = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: ${vw(100)};
  color: #050a30;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${(props) => (props.$index % 2 === 0 ? 'row-reverse' : 'row')};
  gap: ${vw(80)};
  padding: ${vw(50)} ${vw(100)};
  height: ${vw(600)};
`;

const ShowImg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: ${vw(350)};
  height: 100%;
`;

const ShowText = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  gap: ${vw(30)};
  width: ${vw(350)};
  position: relative;
`;

const TextHead = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.$index % 2 === 0 ? 'flex-start' : 'flex-end')};
  text-align: ${(props) => (props.$index % 2 === 0 ? 'left' : 'right')};
  z-index: 1;
`;

const TextFoot = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-self: ${(props) => (props.$index % 2 === 0 ? 'flex-end' : 'flex-start')};
  text-align: ${(props) => (props.$index % 2 === 0 ? 'right' : 'left')};
  z-index: 1;
`;

const Img = styled.img`
  width: 100%;
`;

const TextMiddle = styled.div`
  display: flex;
  flex-direction: column;
  align-self: ${(props) => (props.$index % 2 === 0 ? 'flex-end' : 'flex-start')};
  text-align: ${(props) => (props.$index % 2 === 0 ? 'right' : 'left')};
  z-index: 1;
`;

const TextIconBg = styled.div`
  width: ${vw(180)};
  position: absolute;
  bottom: 0;
  ${(props) => (props.$index % 2 === 0 ? 'left: 0' : 'right: 0')};
  transform: translateY(-20%);
`;

const Line = styled.div`
  width: ${vw(1)};
  height: 80%;
  border-right: ${vw(1)} dashed #000;
  position: relative;

  ::before {
    content: '';
    position: absolute;
    width: ${vw(6)};
    height: ${vw(6)};
    background-color: #000;
    border-radius: 50%;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
  }

  span {
    content: '';
    position: absolute;
    width: ${vw(6)};
    height: ${vw(6)};
    background-color: #000;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: block;
  }

  ::after {
    content: '';
    position: absolute;
    width: ${vw(6)};
    height: ${vw(6)};
    background-color: #000;
    border-radius: 50%;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
  }
`;

const SectionList = [
  {
    imgs: [
      {
        url: '/imgs/webp/jet/type-0-front.webp',
        alt: 'Bombardier Global Express is a large cabin, long-range business jet designed and manufactured by Bombardier Aviation',
      },
      {
        url: '/imgs/webp/jet/type-0-back.webp',
        alt: 'Interior cabin, the Bombardier Global Express kept the Challenger 600 cross section',
      },
    ],
    text: {
      headTitle: 'Ultra Long Range Jets',
      headDesc: 'Our most luxurious flight maxed out with amenities and seating.',
      middleDesc: ['Seats up to 13–16 passengers', 'Flies a range of over 6,000–6,500 miles'],
      footLis: ['Gulfstream G-650ER', 'Gulfstream G-V', 'Gulfstream G-700', 'Global Express'],
    },
  },
  {
    imgs: [
      {
        url: '/imgs/webp/jet/type-1-front.webp',
        alt: 'The Gulfstream IV is a low-wing aircraft with twin aft-mounted turbofans and a T-tail',
      },
      {
        url: '/imgs/webp/jet/type-1-back.webp',
        alt: 'Gulfstream Aerospace G-IV-X Gulfstream G450, Executive Cabin',
      },
    ],
    text: {
      headTitle: 'Heavy Jets',
      headDesc: 'Great for bigger parties, cargo, and additional specialized staff.',
      middleDesc: ['Seats up to 12 passengers', 'Flies a range of over 9,000 miles'],
      footLis: ['Gulfstream G-IVSP', 'Gulfstream G450', 'Challenger 604', 'Challenger 605'],
    },
  },
  {
    imgs: [
      {
        url: '/imgs/webp/jet/type-2-front.webp',
        alt: 'Dassault Falcon 50 French Air Force Private Jet',
      },
      {
        url: '/imgs/webp/jet/type-2-back.webp',
        alt: 'Dassault Falcon 50 private jet charter cabin interior',
      },
    ],
    text: {
      headTitle: 'Super-Midsize Jets',
      headDesc: 'More spacious and quieter cabins for long distance travel.',
      middleDesc: ['Seats up to 8 passengers', 'Flies a range of over 3,500 miles'],
      footLis: ['Citation X', 'Citation Sovereign', 'Falcon 50EX', 'Hawker 1000'],
    },
  },
  {
    imgs: [
      {
        url: '/imgs/webp/jet/type-3-front.webp',
        alt: 'the Learjet 60 has twin turbofans mounted on the fuselage ahead of its T-tail',
      },
      {
        url: '/imgs/webp/jet/type-3-back.webp',
        alt: 'Bombardier Learjet 60 Executive Private Jet Interior Cabin',
      },
    ],
    text: {
      headTitle: 'Midsize Jets',
      headDesc: 'When business and leisure trips require additional amenities and style.',
      middleDesc: ['Seats up to 6–8 passengers', 'Flies a range of over 2,000 miles'],
      footLis: ['Hawker 800XP', 'Citation XLS+', 'Learjet 60', 'Citation Excel'],
    },
  },
  {
    imgs: [
      {
        url: '/imgs/webp/jet/type-4-front.webp',
        alt: 'Embraer Phenom 300 cabin seats for private charter',
      },
      {
        url: '/imgs/webp/jet/type-4-back.webp',
        alt: 'Embraer 505 Phenom 300 Private Jet Rental',
      },
    ],
    text: {
      headTitle: 'Light Jets',
      headDesc: 'Ideal for quick, regional flights and small executive teams.',
      middleDesc: ['Seats up to 6–8 passengers', 'Flies a range of up to 2,000 miles'],
      footLis: ['Phenom 300', 'Hawker 400XP', 'Citation CJ3', 'Nextant 400XTi'],
    },
  },
  {
    imgs: [
      {
        url: '/imgs/webp/jet/type-5-front.webp',
        alt: 'Beechcraft Super King Air turboprop aircraft',
      },
      {
        url: '/imgs/webp/jet/type-5-back.webp',
        alt: 'Beechcraft B200 Super King Air Cabin Interior',
      },
    ],
    text: {
      headTitle: 'Turboprop Aircraft',
      headDesc: 'Ideal for short to medium-range flights, offering versatility and efficiency.',
      middleDesc: ['Seats Up to 6–9 passengers', 'Range Up to 1,800 miles'],
      footLis: [
        'Beechcraft King Air 350',
        'Pilatus PC-12',
        'Piaggio Avanti P180',
        'Cessna Grand Caravan EX',
      ],
    },
  },
  {
    imgs: [
      {
        url: '/imgs/webp/jet/type-6-front.webp',
        alt: 'Piper Cherokee Piston Aircraft For Rent',
      },
      {
        url: '/imgs/webp/jet/type-6-back.webp',
        alt: 'Piston Aircraft Seat Capacity',
      },
    ],
    text: {
      headTitle: 'Piston Aircraft',
      headDesc:
        'Perfect for short-distance travel, providing cost-effective solutions for small groups.',
      middleDesc: ['Seats Up to 4–6 passengers', 'Range Up to 1,200 miles'],
      footLis: ['Cessna 172 Skyhawk', 'Piper PA-28 Cherokee', 'Cirrus SR22', 'Diamond DA40'],
    },
  },
];

const ImgSection = ({ sectionInfo }) => {
  const { imgs } = sectionInfo;
  return (
    <ShowImg>
      {imgs.map((img, index) => (
        <Img src={img.url} alt={img.alt} key={index}></Img>
      ))}
    </ShowImg>
  );
};

const TextSection = ({ sectionInfo, sectionIndex }) => {
  const { headTitle, headDesc, middleDesc, footLis } = sectionInfo.text;

  return (
    <ShowText>
      <TextHead $index={sectionIndex}>
        <H3 id={headTitle}>{headTitle}</H3>

        <Span>{headDesc}</Span>
      </TextHead>
      <TextMiddle $index={sectionIndex}>
        {middleDesc.map((item, index) => (
          <Span key={index}>{item}</Span>
        ))}
      </TextMiddle>
      <TextFoot $index={sectionIndex}>
        <Span $weight={600}>Models include</Span>
        {footLis.map((li, index) => (
          <Li key={index}>{li}</Li>
        ))}
      </TextFoot>
      <TextIconBg $index={sectionIndex}>
        <SvgIcon src={`/imgs/svg/jet/Jet-${sectionIndex}.svg`} alt={headTitle}></SvgIcon>
      </TextIconBg>
    </ShowText>
  );
};

const JetTypeSection = () => (
  <Sections>
    {SectionList.map((sectionInfo, index) => (
      <Container key={index} $index={index} id={sectionInfo.text.headTitle}>
        <ImgSection sectionInfo={sectionInfo} />
        <Line>
          <Span />
        </Line>
        <TextSection sectionInfo={sectionInfo} sectionIndex={index} />
      </Container>
    ))}
  </Sections>
);

export default JetTypeSection;
